var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AnnouncementTable',{attrs:{"headers_prop":_vm.headers,"list_url_prop":`/announcement/index`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }